import { Logger } from 'common/logger';
import { get } from 'lodash';

export function addOrUpdatePark(state, stateKey, payload, defaults = {}) {
    const { parkName } = payload;

    if (!parkName) {
        Logger.warn('addOrUpdatePark: parkName is undefined', payload);
        return;
    }

    const byIdItem = state[stateKey][parkName];
    const updatedItem = {
        ...defaults,
        ...(byIdItem || {}),
        ...payload,
    };

    state[stateKey][parkName] = updatedItem;
}

export function getById({ state, stateKey, payload, payloadKey = 'entityKey' }) {
    const { parkName } = payload;
    const entityKey = get(payload, payloadKey);

    if (!parkName) {
        Logger.warn('getById: parkName is undefined', payload);
        return null;
    }

    if (!entityKey) {
        Logger.warn('getById: entityKey is undefined', payload);
        return null;
    }

    if (!state[stateKey][parkName]) {
        return null;
    }

    return state[stateKey][parkName][entityKey];
}

export function addOrUpdateById({ state, stateKey, payload, defaults = {}, payloadKey = 'entityKey' }) {
    const { parkName } = payload;
    const entityKey = get(payload, payloadKey);

    if (!parkName) {
        Logger.warn('addOrUpdateById: parkName is undefined', payload);
        return;
    }

    if (!entityKey) {
        Logger.warn('addOrUpdateById: entityKey is undefined', payload);
        return;
    }

    if (!state[stateKey][parkName]) {
        state[stateKey][parkName] = {};
    }

    const byIdItem = state[stateKey][parkName][entityKey];
    const updatedItem = {
        ...defaults,
        ...(byIdItem || {}),
        ...payload,
    };

    state[stateKey][parkName][entityKey] = updatedItem;
}
